<template>
  <the-sidebar-layout>
    <div slot="sidebar-title">{{company.name}}</div>
    <div slot="sidebar">
      <p>{{company.address}}<br>
      {{company.postalCode}} {{company.postOffice}}<br>
      {{company.country.name}}</p>
      <p>
        {{loc('businessId')}}: {{company.businessId}}<br>
        {{loc('customerNumber')}}: {{company.customerNumber}}<br>
        {{loc('marketingEmail')}}: {{company.marketingEmail}}
        {{loc('marketingPhone')}}: {{company.marketingPhone}}
      </p>

      <button v-if="canEditCompany" class="btn btn--white" v-on:click="editCompany">{{loc('editCompany')}}</button>
      <button v-if="canDeleteCompany" class="btn btn--white" v-on:click="deleteCompany">{{loc('deleteCompany')}}</button>
    </div>
    <div style="float: right; margin-bottom: 20px">
      <span>{{this.loc('records')}}</span>
      <div class="custom-select__dropdown js-custom-select-dropdown" style="width: 80px; position: relative">
        <span class="custom-select__text js-custom-select-textholder">{{selectedValue}}</span>
        <select v-model="selected" @change="$refs.table.setLimit($event.target.value)" class="form__field-select js-custom-select form__field-select-custom js-lang-select lang_select">
          <option v-bind:text="10" value="10">10</option>
          <option v-bind:text="25" value="25">25</option>
        </select>
      </div>
    </div>
    <v-client-table ref="table" :columns="columns" :data="filteredData" :options="options">
      <div slot="name" slot-scope="props">{{props.row.lastName}}, {{props.row.firstName}}</div>
      <a slot="username" :href="getEmailLink(props.row.username)" slot-scope="props">{{props.row.username}}</a>
      <a slot="phone" :href="getTelLink(props.row.phone)" slot-scope="props">{{props.row.phone}}</a>
      <span slot="role" slot-scope="props">{{props.row.translatedRole}}</span>
      <div slot="actions" slot-scope="props" v-if="canEditUsers">
        <button class="btn" v-on:click="editUser(props.row)">{{loc('editUser')}}</button>
        <button class="btn" v-if="canDeleteUser(props.row)" v-on:click="deleteUser(props.row)">{{loc('deleteUser')}}</button>
      </div>
    </v-client-table>
    <button v-if="canAddUser" class="btn btn--white" v-on:click="addUser">{{loc('addUser')}}</button>
    <modal-company ref="companyModal" :modal-mode="'edit'" :modal-data="company"></modal-company>
    <modal-user ref="addUserModal" :modal-mode="'add'" :modal-data="userInitData"></modal-user>
    <modal-user ref="editUserModal" :modal-mode="'edit'" :modal-data="userEditData"></modal-user>
  </the-sidebar-layout>
</template>

<script>

import ModalCompany from './modal-company.vue';
import ModalUser from './modal-user.vue';

export default {
  components: {
    'modal-company': ModalCompany,
    'modal-user': ModalUser
  },
  data: function () {
    return {
      searchText: '',
      searchColumns: ['firstName', 'lastName', 'username', 'phone', 'role'],
      testing: 'jee',
      columns: ['name', 'username', 'phone', 'role', 'actions'],
      sortable: ['name', 'username', 'phone', 'role'],
      filterable: ['name', 'username', 'phone', 'role'],
      userEditData: {},
      isOwnCompany: false,
      companyId: null,
      selected: '10'

    }
  },
  computed: {
    options() {
      return {
        filterable: false,
        headings: {
          name: this.loc('name'),
          username: this.loc('email'),
          phone: this.loc('phone'),
          role: this.loc('role')
        },
        texts: {
            count: this.loc('paginationCount'),
            limit: this.loc('records'),
            noResults: this.loc('noMatchingResults'),
        }
      };
    },
    company() {
      for(let i=0, l=this.$store.state.companies.length; i<l; i++) {
        if(this.$store.state.companies[i].id === this.companyId) {
          return this.$store.state.companies[i];
        }
      }
      return {
        country: {}
      }
    },
    canEditCompany() {
      // If user has admin role
      return this.$userRights.hasRight( window.RIGHTS.CLIENT_EDIT_COMPANY, this.$store.state.user.role );
    },
    canAddUser() {
      // If user has admin role
      if(this.company.type == 'importer') {
        return false;
      } else {
        return this.$userRights.hasRight( window.RIGHTS.CLIENT_ADD_USERS_COMPANY, this.$store.state.user.role );

      }
    },
    canDeleteCompany() {

      // You can not delete own company
      if(this.companyId === this.$store.state.user.company.id) {
        return false;
      }

      // If user has admin role
      if(this.$userRights.hasRight( window.RIGHTS.CLIENT_DELETE_COMPANY, this.$store.state.user.role ) && !this.companyUsers.length) {
        return true;
      }

      return false;
    },
    canEditUsers() {
      switch(this.company.type) {
        case 'retailer':
          return this.$userRights.hasRight( window.RIGHTS.CLIENT_EDIT_RETAILER_COMPANY_USERS, this.$store.state.user.role );
          break;
        case 'importer':
          return this.$userRights.hasRight( window.RIGHTS.CLIENT_EDIT_IMPORTER_COMPANY_USERS, this.$store.state.user.role );
          break;
      }
      
      return false;
    },
    companyUsers() {
      return this.$store.state.users.filter(user => {
        return user.company === this.company.id;
      });
    },
    userInitData() {
      return {
        companyId: this.company.id,
        countryCode: this.company.country && this.company.country.countryCode || ''
      }
    },
    filteredData: function () {
      const self = this;
      const searchText = this.$store.state.subheader.searchText; // Use subheader search input for searching
      const data = this.companyUsers;

      //create translated Role == translatedRole
      //get translated role from localisation
      data.map( data => {
        let roleCamelCase = data.role.replace(/^[\W_]*|[\W_]*$/g, '') // Remove ![a-z0-9] chars from beginning and end of string, for example "__foo--" => "foo"
                                 .replace(/[_-\s]([a-z0-9])/g, function (g) { return g[1].toUpperCase(); }) // Capitalize letters that come after "-", "_" and " "
                                 .replace(/[_-\s]/g, ''); // Remove all "-", "_" and " "
        data.translatedRole = roleCamelCase != '' ?  this.loc('user.roles.' + roleCamelCase ) : '';
        return data;
      });

      if(searchText) {
        const searchRegEx = new RegExp(searchText, 'i')

        return data.filter(function (item) {
          for(let i=0, l=self.searchColumns.length; i<l; i++) {
            const column = self.searchColumns[i];

            if(searchRegEx.test(item[column])) {
              return true;
            }
          }
          return false;
        });
      }
      return data;
    },
    selectedValue() {
      return this.selected;
    }
  },
  methods: {
    canDeleteUser(userData) {
      // Can not delete self
      return userData.id !== this.$store.state.user.info.id;
    },
    deleteCompany() {
      const confirmMessage = this.loc('deleteConfirmation').replace('{{target}}', this.company.name);

      if(confirm(confirmMessage)) {
        return this.$api.deleteCompany(this.company.id).then(res => {
          if(res.code === 200) {
            this.$store.commit('deleteCompany', this.company.id);
            this.$router.replace({name: 'home'});
          }
        });
      }
    },
    editCompany() {
      this.$refs.companyModal.show();
    },
    editUser(userData) {
      this.userEditData = userData;
      this.$refs.editUserModal.show();
    },
    addUser() {
      this.$refs.addUserModal.show();
    },
    deleteUser(userData) {
      const confirmMessage = this.loc('deleteConfirmation').replace('{{target}}', userData.lastName + ', ' + userData.firstName)

      if(confirm(confirmMessage)) {
        return this.$api.deleteUser(userData.id).then(res => {
          if(res.code === 200) {
            this.$store.commit('deleteUser', userData.id);
          }
        });
      }
    },
    getEmailLink(email) {
      return 'mailto:' + email;
    },
    getTelLink(phone) {
      return 'tel:' + phone;
    }
  },
  mounted: function () {

    // Check if we have param /company/:id and use that else use logged in user's company as default
    this.companyId = this.$route.params.id || this.$store.state.user.company.id;

    if(!this.$route.params.id) {
      this.isOwnCompany = true;
    }

    this.$store.dispatch('getCompany', this.companyId);
    this.$store.dispatch('getCompanyUsers', this.companyId);

    this.$store.commit('setSubheader', {
      subtitle: '',
      title: '',
      description: '',
      searchEnabled: true
    });
  }
}
</script>

<style>
</style>
